// biome-ignore lint/style/noRestrictedImports: the one place that wraps react-router's navigate (use useAppNavigate elsewhere)
import { type NavigateFunction, useNavigate } from 'react-router';

/** react-router's navigate - import this instead of useNavigate (biome noRestrictedImports, like bb-auth) */
export function useAppNavigate(): NavigateFunction {
  return useNavigate();
}
